import React from "react"
import { facilityGroupCodeShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"

const FacilityGroupCode = ({ facilityGroupCode }) => (
  <ItemRow
    className="dark"
    itemRowHeaderContent={(
      <span>{facilityGroupCode.name}</span>
    )}
  />
)

FacilityGroupCode.propTypes = {
  facilityGroupCode: facilityGroupCodeShape.isRequired,
}

export default FacilityGroupCode
